export interface Language {
  value: string;
  label: string;
}

export const languages: Language[] = [
  { value: 'python', label: 'Python' },
  { value: 'java', label: 'Java' },
  { value: 'javascript', label: 'JavaScript' },
  { value: 'typescript', label: 'TypeScript' },
  { value: 'cobol', label: 'COBOL' },
  { value: 'json', label: 'JSON' },
  { value: 'sql', label: 'SQL' },
  { value: 'xml', label: 'XML' },
];

export default languages;
